export const accountPages = ['routes/_menu.$basename.account'];

export const authPages = [
  'routes/_menu.$basename.login._index',
  'routes/_menu.$basename.login.email',
  'routes/_menu.$basename.forgot-password',
  'routes/_menu.$basename.reset-password',
  'routes/_menu.$basename.signup',
];

export const customRowPages = [
  'routes/_menu.$basename.($storeSlug).rows.$customRowId.$slug',
  'routes/_menu.$basename.store.$storeId.rows.$customRowId.$slug',
];

export const featuredPages = [
  'routes/_menu.$basename.($storeSlug).featured._index',
  'routes/_menu.$basename.store.$storeId.featured._index',
];

export const categoryPages = [
  'routes/_menu.$basename.($storeSlug).edible._index',
  'routes/_menu.$basename.($storeSlug).extract._index',
  'routes/_menu.$basename.($storeSlug).flower._index',
  'routes/_menu.$basename.($storeSlug).gear._index',
  'routes/_menu.$basename.($storeSlug).grow._index',
  'routes/_menu.$basename.($storeSlug).merch._index',
  'routes/_menu.$basename.($storeSlug).pre-roll._index',
  'routes/_menu.$basename.($storeSlug).tincture._index',
  'routes/_menu.$basename.($storeSlug).topical._index',
  'routes/_menu.$basename.($storeSlug).vape._index',
  'routes/_menu.$basename.($storeSlug).shop-all._index',

  'routes/_menu.$basename.store.$storeId.edible._index',
  'routes/_menu.$basename.store.$storeId.extract._index',
  'routes/_menu.$basename.store.$storeId.flower._index',
  'routes/_menu.$basename.store.$storeId.gear._index',
  'routes/_menu.$basename.store.$storeId.grow._index',
  'routes/_menu.$basename.store.$storeId.merch._index',
  'routes/_menu.$basename.store.$storeId.pre-roll._index',
  'routes/_menu.$basename.store.$storeId.tincture._index',
  'routes/_menu.$basename.store.$storeId.topical._index',
  'routes/_menu.$basename.store.$storeId.vape._index',
  'routes/_menu.$basename.store.$storeId.shop-all._index',
];

export const plpPages = [
  ...featuredPages,
  ...categoryPages,
  ...customRowPages,

  'routes/_menu.$basename.search',

  'routes/_menu.$basename.($storeSlug).deals._index',
  'routes/_menu.$basename.($storeSlug).deals.$dealId.$slug',
  'routes/_menu.$basename.($storeSlug).jane-gold._index',
  'routes/_menu.$basename.($storeSlug).jane-gold.$specialId.$slug',

  'routes/_menu.$basename.store.$storeId.deals._index',
  'routes/_menu.$basename.store.$storeId.deals.$dealId.$slug',
  'routes/_menu.$basename.store.$storeId.jane-gold._index',
  'routes/_menu.$basename.store.$storeId.jane-gold.$specialId.$slug',
];

export const pdpPages = ['routes/_menu.$basename.products.$productId.$slug'];
